import { SimpleEntity } from 'app/projects/shared/src/lib/models/simple-entity.model';
import { IPerformanceProfilePersonalReviewQuery } from '../interfaces/performance-profile-personal-review.query.interface';

// @dynamic
export class PerformanceProfilePersonalReview {
    id: string;
    name: string;
    type: SimpleEntity;
    team: SimpleEntity;
    status: string;
    startDate: string;
    dueDate: string;
    goalSettingPeriod: {
        id: string;
    };
    periodUnderReview: {
        id: string;
    };

    constructor(query: IPerformanceProfilePersonalReviewQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.type = new SimpleEntity(query.type);
        this.team = query.team ? new SimpleEntity(query.team) : null;
        this.status = query.status;
        this.dueDate = query.due_date;
        this.startDate = query.start_date;
        (this.goalSettingPeriod = {
            id: query.goal_setting_period.id.toString(),
        }),
            (this.periodUnderReview = {
                id: query.period_under_review.id.toString(),
            });
    }
}
